import FilterCard from "Components/Common/FilterBar/FilterCard/FilterCard";
import ToggleButton from "Components/Common/ToggleButton/ToggleButton";
import { TaskRecurrencyType } from "Models/Tasks/TaskRecurrencies/TaskRecurrencyType";
import React from "react";
import i18n from "Translations/i18n";

interface IProps {
    selectedRecurrenceTypes: TaskRecurrencyType[];
    onChange: (selectedRecurrenceTypes: TaskRecurrencyType[]) => void;
}

interface IState {
    
}

class RecurrenceFilterCard extends React.Component<IProps, IState> {
    
    constructor(props: IProps) {
        super(props);

        this.state = {
        };

    }

    public getState(recurrenceType: TaskRecurrencyType): boolean {
        return this.props.selectedRecurrenceTypes.indexOf(recurrenceType) !== -1;
    }

    public onToggle(recurrenceType: TaskRecurrencyType, newState: boolean) {
        if(newState) {
            this.props.onChange([...this.props.selectedRecurrenceTypes, recurrenceType]);                
        }
        else {
            const updated = [...this.props.selectedRecurrenceTypes];
            const index = updated.indexOf(recurrenceType);
            if(index > -1) {
                updated.splice(index, 1);
                this.props.onChange(updated);
            }
        }
    }

    public render() {  
        
        return (
            <FilterCard title={i18n.t("taskDetail.recurrence.title")} onClear={this.props.selectedRecurrenceTypes.length ? () => this.props.onChange([]) : undefined}>
                <ToggleButton 
                    onToggle={(newState) => this.onToggle(TaskRecurrencyType.noRecurrency, newState)} 
                    state={this.getState(TaskRecurrencyType.noRecurrency)}>
                    {i18n.t("taskDetail.recurrence.tabTitles.onlyOnce")}
                </ToggleButton>
                <ToggleButton 
                    onToggle={(newState) => this.onToggle(TaskRecurrencyType.shifts, newState)} 
                    state={this.getState(TaskRecurrencyType.shifts)}>
                    {i18n.t("taskDetail.recurrence.tabTitles.certainShifts")}
                </ToggleButton>
                <ToggleButton 
                    onToggle={(newState) => this.onToggle(TaskRecurrencyType.week, newState)} 
                    state={this.getState(TaskRecurrencyType.week)}>
                    {i18n.t("taskDetail.recurrence.tabTitles.dailyWeekly")}
                </ToggleButton>
                <ToggleButton 
                    onToggle={(newState) => this.onToggle(TaskRecurrencyType.month, newState)} 
                    state={this.getState(TaskRecurrencyType.month)}>
                    {i18n.t("taskDetail.recurrence.tabTitles.monthly")}
                </ToggleButton>
            </FilterCard>
        );
    }
}

export default RecurrenceFilterCard;


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateFilters/CustomFilterCards/RecurrenceFilter/RecurrenceFilterCard.tsx